export enum AvailabilityResultLink {
    HOMES_PASSED = 'https://eweb8.vfd2-testnet.de/privat/fernsehen/kabelanschluss-bau.html?icmp=vp_up_cabangebot',
    OPTION_PAGE = 'https://zuhauseplus.vodafone.de/optionen/'
}
